import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Cart\CartAddSetController::__invoke
* @see Http/Controllers/Api/Cart/CartAddSetController.php:20
* @route '/cart/add-set'
*/
const CartAddSetController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CartAddSetController.url(options),
    method: 'post',
})

CartAddSetController.definition = {
    methods: ["post"],
    url: '/cart/add-set',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Api\Cart\CartAddSetController::__invoke
* @see Http/Controllers/Api/Cart/CartAddSetController.php:20
* @route '/cart/add-set'
*/
CartAddSetController.url = (options?: RouteQueryOptions) => {
    return CartAddSetController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Cart\CartAddSetController::__invoke
* @see Http/Controllers/Api/Cart/CartAddSetController.php:20
* @route '/cart/add-set'
*/
CartAddSetController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CartAddSetController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Cart\CartAddSetController::__invoke
* @see Http/Controllers/Api/Cart/CartAddSetController.php:20
* @route '/cart/add-set'
*/
const CartAddSetControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: CartAddSetController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Api\Cart\CartAddSetController::__invoke
* @see Http/Controllers/Api/Cart/CartAddSetController.php:20
* @route '/cart/add-set'
*/
CartAddSetControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: CartAddSetController.url(options),
    method: 'post',
})

CartAddSetController.form = CartAddSetControllerForm

export default CartAddSetController